<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
  >
    <base-phone-input
      v-model="model"
      v-bind="$attrs"
      :class="{ 'is-invalid': errorMessage }"
    />
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
const model = defineModel<string | unknown>()

defineProps({
  id: {
    type: [String || Number],
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  note: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  fieldClass: {
    type: String,
    default: '',
  },
})
</script>
